<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="300px" spinnerName="simpleSignupLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      <div class="col-md-12 m-b-20">
        <fui-heading level="5" textAlign="center" text="ONE LOGIN FOR ALL."></fui-heading>
        <div class="d-flex align-items-center justify-content-center m-t-20">
          <myp-svg id="fender-logo" class="svg-neutral" width="100" height="30"></myp-svg>
          <div class="m-x-20">&bull;</div>
          <!-- <myp-svg id="fender-studio-logo" class="svg-neutral" width="130" height="30"></myp-svg>
          <div class="m-x-20">&bull;</div> -->
          <myp-svg id="presonus-logo" class="svg-neutral" width="100" height="30"></myp-svg>
        </div>
        <br />
        <br />
        <p [innerHTML]="'login_updates.unifying_accounts' | translate: { fromAccount: 'PreSonus', toAccount: 'Fender', email: email }"></p>
        <p [innerHTML]="'login_updates.to_connect_accounts' | translate: { loginAccount: 'PreSonus' }"></p>
        <div [innerHTML]="'login_updates.nothing_else_changing' | translate"></div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label">{{ "profile.edit.email" | translate }}</label>
        <input type="text" (keyup.enter)="submit()" class="form-control" [(ngModel)]="email" />
      </div>
      <div class="form-group col-md-12">
        <label class="control-label">{{ "general.password" | translate }}</label>
        <input [type]="passwordVisible ? 'text' : 'password'" (keyup.enter)="submit()" class="form-control" [(ngModel)]="password" />
      </div>
      <div class="col-md-12">
        <myp-switch [active]="passwordVisible" label="Show password" [labelToRight]="true" (toggle)="passwordVisible = !passwordVisible"></myp-switch>
      </div>
      <div class="text-left m-t-20 col-md-12">
        <span class="link bold t-12" data-cy="forgot-password-link" (click)="startForgotPassword()">{{ "profile.forgot_password" | translate }}</span>
      </div>
      <div class="col-md-12 text-center">
        @if (errorMessage) {
          <div class="api-error-message">{{ errorMessage }}</div>
        }
      </div>
    </div>
  }
</div>
@if (!loading) {
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="submit()">Log In</button>
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
